import { useEffect, useState } from "react";
import type { MeResponse } from "@saas-on-sheets/auth-client";
import { createAuthClient } from "@saas-on-sheets/auth-client";
import { createHelloAppClient } from "./api/helloAppClient.ts";
import { LoginPage } from "./pages/LoginPage.tsx";
import { DashboardPage } from "./pages/DashboardPage.tsx";
import { env } from "./env.ts";

const authClient = createAuthClient({ authApiUrl: env.VITE_AUTH_API_URL });
const appClient = createHelloAppClient({
  appApiUrl: env.VITE_APP_API_URL,
  authApiUrl: env.VITE_AUTH_API_URL,
});

type AppState =
  | { kind: "loading" }
  | { kind: "logged-out" }
  | { kind: "logged-in"; me: MeResponse };

export function App() {
  const [state, setState] = useState<AppState>({ kind: "loading" });

  async function refreshMe(): Promise<void> {
    try {
      const me = await authClient.getMe({ appId: env.VITE_APP_ID });
      setState(me ? { kind: "logged-in", me } : { kind: "logged-out" });
    } catch {
      setState({ kind: "logged-out" });
    }
  }

  useEffect(() => {
    void refreshMe();
  }, []);

  if (state.kind === "loading") {
    return (
      <div className="app-loading" role="status" aria-live="polite">
        <span>Loading…</span>
      </div>
    );
  }
  if (state.kind === "logged-out") {
    return <LoginPage authClient={authClient} />;
  }
  return (
    <DashboardPage
      me={state.me}
      authClient={authClient}
      appClient={appClient}
      onLogout={() => setState({ kind: "logged-out" })}
      onRefreshMe={refreshMe}
    />
  );
}
